import { EpimsBaseEntityDto } from './epim-base.dto';

export class ResponseRoleDto extends EpimsBaseEntityDto {
  ResponsePersonEmail: string;
  ResponsePersonName: string;
}
